var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",style:(_vm.barStyle)},[(_vm.duration != 0)?_c('div',{staticClass:"chunk",style:(_vm.chunkStyle)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }